import { DialogTitle, Typography } from "@mui/material";
import CloseButton from "atoms/Buttons/CloseButton";
import { CloseDialogType } from "organisms/ButtonOrMenuItemWithDialog";
import { ReactNode } from "react";

type ClosableDialogTitlePropsType = {
  closeDialog: CloseDialogType;
  children?: ReactNode;
  disabled?: boolean;
  subtitle?: ReactNode | string;
};

export default function ClosableDialogTitle(props: ClosableDialogTitlePropsType) {
  const { closeDialog, children, disabled = false, subtitle = null } = props;

  return (
    <DialogTitle
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <div>
        <Typography variant="h6" component="h2">
          {children}
        </Typography>
        {subtitle}
      </div>
      {closeDialog && (
        <CloseButton data-testid="close-dialog" disabled={disabled} onClick={closeDialog} sx={{ ml: 2 }} />
      )}
    </DialogTitle>
  );
}
